module.exports = __webpack_public_path__ + "static/media/jp-yen.4bea8d54.svg";